import { Box, Tooltip } from "@mui/material";
import { useDesignTokens } from "../../../theme/useDesignTokens";

/**
 * Common SwitchButton Component
 */

const SwitchButton = ({
  id,
  checked,
  onChange,
  tooltip,
  size,
  disabled = false,
}) => {
  const { colors } = useDesignTokens();
  const sucMain = colors?.success?.main;
  const disMain = colors?.disabled?.main;

  return (
    <Tooltip key={id} title={tooltip} arrow>
      <Box
        // onClick={!disabled ? onChange : undefined}
        role="switch"
        tabIndex={disabled ? -1 : 0}
        aria-checked={checked}
        aria-disabled={disabled}
        onClick={(e) => {
          if (!disabled && typeof onChange === "function") {
            onChange(e);
          }
        }}
        onKeyDown={(e) => {
          if (disabled) return;
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            if (typeof onChange === "function") onChange(e);
          }
        }}
        sx={{
          width: 36,
          height: 18,
          borderRadius: "999px",
          backgroundColor: checked ? sucMain : disMain,
          position: "relative",
          cursor: disabled ? "not-allowed" : "pointer",
          transition: "background-color 0.2s ease",
          flexShrink: 0,

          /* Hard reset against Materialize */
          boxSizing: "border-box",
          padding: 0,
          margin: 0,
          border: "none",
          outline: "none",

          "& *": {
            boxSizing: "border-box",
          },
        }}
      >
        <Box
          sx={{
            width: 14,
            height: 14,
            borderRadius: "50%",
            backgroundColor: "#fff",
            position: "absolute",
            top: 2,
            left: checked ? 20 : 2,
            transition: "left 0.2s ease",
            boxShadow: "0 1px 3px rgba(0,0,0,0.3)",

            /* Prevent pseudo-element injection */
            "&::before, &::after": {
              //   content: "none",
              content: '""',
              display: "none",
            },
          }}
        />
      </Box>
    </Tooltip>
  );
};

export default SwitchButton;
